function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 14.667A6.667 6.667 0 108 1.333a6.667 6.667 0 000 13.334z",
  stroke: "#FFDE3A",
  strokeWidth: 1.333
});

var SvgBespokenIconSkipped = function SvgBespokenIconSkipped(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
};

export default SvgBespokenIconSkipped;